import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { API } from "@/lib/api";

export const REASONS = {
  harassment: "Zaklatás, fenyegetés",
  nudity: "Meztelenség, szexuális tartalom",
  minor: "Kiskorúnak tűnik",
  hate: "Gyűlöletbeszéd",
  spam: "Spam, reklám, csalás",
  illegal: "Illegális tartalom",
  other: "Egyéb",
};

export const ReportDialog = ({ chat, open, onOpenChange }) => {
  const [reason, setReason] = useState("harassment");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/report`, { peer_id: chat.peerIdRef.current, reason, details });
      toast.success("Köszönjük, a jelentést továbbítottuk az adminnak.");
      onOpenChange(false);
      setDetails("");
      setReason("harassment");
      if (chat.status === "chatting") chat.next();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Nem sikerült elküldeni a jelentést");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md border-white/10 bg-[#1A152E]" data-testid="report-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-2xl"><Flag className="h-5 w-5 text-[#FF3B6C]" /> Partner jelentése</DialogTitle>
          <DialogDescription>Az admin megnézi a beszélgetést, és szükség esetén kitiltja a partnert. Jelentés után új partnert keresünk neked.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-2">
          {Object.entries(REASONS).map(([k, l]) => (
            <label key={k} className={`flex cursor-pointer items-center gap-3 rounded-2xl border px-4 py-2.5 text-sm transition-colors ${reason === k ? "border-[#FF3B6C] bg-[#FF3B6C]/10" : "border-white/10 hover:bg-white/5"}`}>
              <input type="radio" name="reason" value={k} checked={reason === k} onChange={() => setReason(k)} className="accent-[#FF3B6C]" data-testid={`report-reason-${k}`} />
              {l}
            </label>
          ))}
        </div>
        <textarea value={details} onChange={(e) => setDetails(e.target.value)} maxLength={1000} rows={3} data-testid="report-details-input"
          placeholder="Mi történt? (opcionális)" className="w-full rounded-2xl border border-white/10 bg-white/5 p-3 text-sm outline-none focus:border-[#FF3B6C]" />
        <button onClick={submit} disabled={busy} data-testid="report-submit-button"
          className="rounded-full bg-[#FF3B6C] px-6 py-3 font-bold text-white transition-transform hover:scale-[1.02] disabled:opacity-50">
          {busy ? "Küldés…" : "Jelentés elküldése"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
